/**
 * Replaces phone numbers using rules.
 * 
 * Rule format: PHONE_TO_MASK,MASK_NUMBER,CONSTRAINTS
 * Example:     01268 730788,0845 123456,utm_source=google&utm_medium=cpc
 * 
 * @since 1.14.0
 * @package dealerkit-wp
 */
export class PhoneNumberMaskProcessor
{
    constructor(window)
    {
        this.w = window
    }

    /**
     * Replace numbers within a given set of anchor 
     * elements with the array of rules provided.
     * 
     * @param {*} rules 
     * @param {*} elements 
     */
    replaceElements(rules, elements)
    {
        elements.forEach(e => {
            let content = e.outerHTML
            content = this.processRules(rules, content)
            e.outerHTML = content.replaceAll('data-dk-phone-link', '')
        })
    }

    /**
     * Replace numbers within a given piece of textual content 
     * using the array of rules provided.
     * 
     * @param {*} rules 
     * @param {*} content 
     * @returns 
     */
    processRules(rules, content)
    {
        rules.forEach(rule => {
            content = this.runRule(rule, content)
        })

        return content
    }

    /**
     * Replace numbers within a given piece of textual content 
     * using the rule provided.
     * 
     * @param {*} rule 
     * @param {*} content 
     * @returns 
     */
    runRule(rule, content)
    {
        if (typeof this.w.dkTracking !== 'object')
            throw Error('DealerKit Forms not loaded.')

        if (typeof content !== 'string')
            throw Error('Content must be a string.')

        // Split the rule into it's three parts, 
        // 1) number to mask 2) number to mask with 3) constraints
        const parts = rule.trim().split(',')

        if (parts.length !== 3) {
            return content
        }

        // Split constraints string and then split each constrait 
        // into its key and expected value.
        const constraints = parts[2].split('&').map(parts => {
            return parts.split('=')
        })

        // Test each constraint, if it fails return the unmodified content.
        if (constraints.length > 0 && parts[2].trim() !== '') {
            for (const constraint of constraints) {
                const value = this.w.dkTracking.get(constraint[0]);
                const exp = new RegExp(`${value}`, "i")
                if (!value || !exp.exec(constraint[1].trim())) {
                    return content;
                }
            }
        }

        // Replace the original (e.g. 01234 567890) or collapsed 
        // number (e.g. 01234567890) with the new number.
        const searchFor = parts[0]
        const searchForAlt = parts[0].replace(' ', '')

        const replaceWith = parts[1]
        const replaceWithAlt = parts[1].replace(' ', '')

        return content
            .replaceAll(searchFor, replaceWith)
            .replaceAll(searchForAlt, replaceWithAlt)
    }
}